"use client"
import * as React from "react";
import {ReactNode} from "react";
import PSection from "./p-section";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import FaIcon from "@/components/utilities/fa-icon";

import {Paper} from "@mui/material";

export default function PContentSection({children, name, title, subtitle, faIcon}:
                                        {
                                            children: ReactNode,
                                            title: string,
                                            name: string,
                                            faIcon: string,
                                            subtitle?: string
                                        }) {

    return (
        <PSection title = {name} faIcon = {faIcon} >
            <Paper sx = {{minHeight: 140, p: 2, pl:  2}} >
                <Box
                    mb = {2}
                    width = '100%'
                    display = 'flex'
                    justifyContent = 'space-between'
                    alignItems = 'center'
                >
                    <Typography variant = 'h6' display = "flex" alignItems = "center" gap = {1} >
                        <FaIcon fontSize = {20} faIcon = {faIcon} />

                        {title}
                    </Typography >
                    <Typography fontWeight = {400} color = "primary.main" variant = "body2" >
                        {subtitle}
                    </Typography >
                </Box >
                {children}
            </Paper >
        </PSection >
    )
}